import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import all necessary components
import NoMatch from './components/404';
import NavBar from './components/NavBar';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard';
import AddNewVehicles from './pages/AddNewVehicles/AddNewVehicles';
import Management from './pages/Managment';
import VehiclesList from './pages/VehiclesList';
import Log from './pages/Log';
import ListV2 from './components/List/ListV2';
import Add from './components/List/Add';
import HasParentList from './components/HasParentList';
import PickupLocationList from './components/PickupLocationList';
import AddPickUp from './components/PickupLocationList/Add';

import UserList from './components/UserList';
import AddUser from './components/UserList/AddUser';
import ChangePassword from './components/UserList/ChangePassword';
import AccountChangePassword from './components/Account/AccountChangePassword';
import BookingList from './components/BookingList/BookingList';
import AddBooking from './components/BookingList/AddBooking';
import ClientList from './components/Client/ClientList';
import AddClient from './components/Client/AddClient';
import ClientChangePassword from './components/Client/ChangePassword';
import Loader from './components/Loader';
import ClientDashboard from './pages/Client/ClientDashboard';
import ClientHome from './pages/Client/ClientHome';
import Vehicles from './pages/Vehicles/Vehicles';
import Booking from './pages/Booking/Booking';
import AddNewBooking from './pages/Booking/AddNewBooking/AddNewBooking';
import AddConsignee from './components/List/AddConsignee';
import Shipments from './pages/Shipments/Shipments';
import AddShipment from './pages/Shipments/AddNewShipment/AddShipment';
import Jobs from './pages/Jobs/Jobs';
import Container from './pages/Container/Container';
import ChangePasswordClient from './pages/Client/ChangePasswordClient';
import { persistor } from './store/store';
import AddConsigneeDock from './components/List/AddConsigneeDock';
import AddNameAndEmail from './components/List/AddNameAndEmail';


// MasterRoute component to handle routing based on user authentication and roles
function MasterRoute() {



    const { isAuthenticate,  loading , accountType } = useSelector((state) => state.user);

    const isClient = accountType === 'client';

    // run purge/clear as a side-effect when auth becomes false
    useEffect(() => {
        if (!isAuthenticate) {
            try {
                persistor.purge();
            } catch (e) {
                // ignore persistor errors
            }
            try {
                localStorage.clear();
                sessionStorage.clear();
            } catch (e) {
                // ignore storage clear errors
            }
        }
    }, [isAuthenticate]);

    if (loading) {
        return <Loader />;
    }


    // Admin Routes - All routes accessible by admin users
    const AdminRoutes = (
        <Routes>
            <Route path='/' element={<NavBar />}>
                <Route index element={<Dashboard />} />
                <Route path='/Vehicles' element={<Vehicles />} />
                <Route path='/jobs' element={<Jobs />} />
                <Route path='/VehicleaddEdit' element={<AddNewVehicles />} />
                <Route path='/management' element={<Management />} />
                <Route path='/vehiclesList' element={<VehiclesList />} />
                <Route path='/booking' element={<Booking />} />
                <Route path='/addBooking' element={<AddNewBooking />} />
                <Route path='/containers' element={<Container />} />
                <Route path='/Shipments' element={<Shipments />} />
                <Route path='/addShipment' element={<AddShipment />} />
                <Route path='/log' element={<Log />} />
                <Route path='/:mode/view' element={<ListV2 />} />
                <Route path='/:mode/add' element={<Add />} />
                <Route path='/:mode/list' element={<HasParentList />} />
                <Route path='/:mode/pickup' element={<PickupLocationList />} />
                <Route path='/:mode/addPickup' element={<AddPickUp />} />
           
                <Route path='/:mode/userList' element={<UserList />} />
                <Route path='/:mode/addUser' element={<AddUser />} />
                <Route path='/:mode/updatePassword' element={<ChangePassword />} />

                {!isClient ?(<Route path='/updatePassword' element={<AccountChangePassword />} />) : 
                
                (<Route path='/updatePassword' element={<ChangePasswordClient />} />)
                }
                
                
                <Route path='/:mode/bookingList' element={<BookingList />} />
                <Route path='/:mode/addBooking' element={<AddBooking />} />
                <Route path='/:mode/clientList' element={<ClientList />} />
                <Route path='/:mode/addClient' element={<AddClient />} />
                <Route path='/:mode/addConsignee' element={<AddConsignee />} />
                <Route path='/:mode/addConsigneeDock' element={<AddConsigneeDock />} />
                <Route path='/:mode/addNameAndEmail' element={<AddNameAndEmail  />} />

                <Route path='/:mode/updateClientPassword' element={<ClientChangePassword />} />
                <Route path='/login' element={<Navigate replace to="/" />} />
            </Route>


            <Route path='/ClientDashboard' element={<ClientDashboard />} >
                <Route path='/ClientDashboard' element={<ClientHome />} />
            </Route>




            <Route path='*' element={<NoMatch />} />
        </Routes>
    );

   

    // Non-authenticated Routes - Only the login page
    const NonAuthenticatedRoutes = (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path='*' element={<Navigate replace to="/login" />} />
        </Routes>
    );



    // Conditional rendering based on authentication and account type
    if (isAuthenticate) {
        return AdminRoutes;
    } else {
        return NonAuthenticatedRoutes;
    }
}

export default MasterRoute;
